export default {
  data: () => ({
    rawData: [],
    json: null,

    dataSet: [
      
      {type: 'System',     name: 'J2_Filter_Viewer',      url: ''},
      {type: 'System',     name: 'Filter_Viewer',         url: ''}, // ##
      {type: 'System',     name: 'Text_Editor',           url: ''},
      {type: 'System',     name: 'Sundries2',             url: '#/cp/Sundries2'},
      {type: 'System',     name: 'Index_BlockStage',      url: '#/cp/Index_BlockStage'},

      // Summaries
      {type: 'Summaries',  name: 'Simple_A',              url: '#/cp/Simple_A'},
      {type: 'Summaries',  name: 'Status_A',              url: '#/cp/Status_A'},
      {type: 'Summaries',  name: 'Status_B',              url: '#/cp/Status_B'},
      {type: 'Summaries',  name: 'Status_Group',          url: '#/cp/Status_Group'},
      {type: 'Summaries',  name: 'Status_Punch',          url: '#/cp/Status_Punch'},

      {type: 'Summaries',  name: 'Progress_A',            url: '#/cp/Progress_A'},
      {type: 'Summaries',  name: 'Progress_B',            url: '#/cp/Progress_B'},
      {type: 'Summaries',  name: 'Progress_C',            url: '#/cp/Progress_C'},

      {type: 'Summaries',  name: 'Cube_A',                url: '#/cp/Cube_A'},
      {type: 'Summaries',  name: 'Cube_C',                url: '#/cp/Cube_C'}, // to be deleted
      {type: 'Summaries',  name: 'Cube_SC',               url: '#/cp/Cube_SC'},
      {type: 'Summaries',  name: 'WeekStatus',            url: '#/cp/WeekStatus'},
      {type: 'Summaries',  name: 'Donut_Status',          url: '#/cp/Donut_Status'},
      


      // DataTables TBL_Scrollbar
      {type: 'DataTables', name: 'TBL_Integration',       url: '#/table/Integration'},
      {type: 'DataTables', name: 'TBL_Scrollbar',         url: '#/table/Scrollbar'},
      {type: 'DataTables', name: 'TBL_Modal_Normal',      url: '#/table/Modal_Normal'},
      {type: 'DataTables', name: 'TBL_NDE_Normal',        url: '#/table/NDE_Normal'},
      {type: 'DataTables', name: 'TBL_NDE_Trion',         url: '#/table/TBL_NDE_Trion'},
      {type: 'DataTables', name: 'TBL_Progress',          url: '#/table/Progress'},
      {type: 'DataTables', name: 'TBL_Punch',             url: '#/table/Punch'},

      // Primavera
      {type: 'Primavera',  name: 'P6_TABLE_EL',           url: '#/p6/Table_EL'},
      {type: 'Primavera',  name: 'P6_TABLE_MD',           url: '#/p6/Table_MD'},
      {type: 'Primavera',  name: 'P6_TUBE_EL',            url: '#/p6/Tube_EL'},
      {type: 'Primavera',  name: 'P6_TUBE_MD',            url: '#/p6/Tube_MD'},
      {type: 'Primavera',  name: 'P6_GAUGE_MD',           url: '#/p6/Gauge_MD'},
      {type: 'Primavera',  name: 'J2_P6_TABLE_EL',        url: '#/p6/Tube_MD'},// ##
      {type: 'Primavera',  name: 'J2_P6_TREND_EL',        url: '#/p6/Gauge_MD'}, // ##
      

      // Histogram

      {type: 'Histogram',  name: 'HIS_SCURVE_MINI',       url: '#/his/Scurve_Mini'},
      {type: 'Histogram',  name: 'HIS_PUNCH_MINI',        url: '#/his/Punch_Mini'},
    
      {type: 'Histogram',  name: 'HIS_STACK',             url: '#/his/Stack'},
      {type: 'Histogram',  name: 'HIS_PUNCH',             url: '#/his/Punch'},
      {type: 'Histogram',  name: 'HIS_PUNCH_STACK',       url: '#/his/Punch_Stack'},
      {type: 'Histogram',  name: 'HIS_SCURVE',            url: '#/his/Scurve'},
      
      {type: 'Histogram',  name: 'BAR_VER_MULTI',         url: '#/bar/Ver_Multi'},
      {type: 'Histogram',  name: 'BAR_HOZ_MULTI',         url: '#/bar/Hoz_Multi'},
      {type: 'Histogram',  name: 'BAR_TRENDS',            url: '#/bar/WeekTrends'},
      {type: 'Histogram',  name: 'BAR_STACKS',            url: '#/bar/WeekTrends'},

      

      // Charts
      {type: 'Charts',     name: 'CHT_RADAR',             url: '#/chart/Radar'},
      {type: 'Charts',     name: 'CHT_DONUT',             url: '#/chart/Donut'},
      {type: 'Charts',     name: 'CHT_PIE',               url: '#/chart/Pie'},
      {type: 'Charts',     name: 'CHT_TUBE',              url: '#/chart/Tube'},
      {type: 'Charts',     name: 'CHT_GAUGE',             url: '#/chart/Gauge'},
      {type: 'Charts',     name: 'CHT_GAUGE_FC',          url: '#/chart/Gauge_FC'},
      {type: 'Charts',     name: 'CHT_GAUGE_QTY',         url: '#/chart/Gauge_Qty'},
      {type: 'Charts',     name: 'CHT_GAUGE_QTY2',        url: '#/chart/Gauge_Qty2'},
      {type: 'Charts',     name: 'CHT_SKYLINE_MINI',      url: '#/chart/Skyline_Mini'},

      // Reports
      {type: 'Reports',    name: 'RPT_SCURVE_MS',         url: '#/report/plan/SCurve_MS'},
      {type: 'Reports',    name: 'RPT_PROGRESS_EL',       url: '#/report/plan/SCurve_MS'},
      {type: 'Reports',    name: 'RPT_SCURVE_BLOCK',      url: '#/report/plan/SCurve_MS'},
      {type: 'Reports',    name: 'RPT_ERECTION_STATUS',   url: '#/report/plan/SCurve_MS'},
      {type: 'Reports',    name: 'RPT_SYSTEM_STATUS',     url: '#/report/plan/SCurve_MS'},
      {type: 'Reports',    name: 'RPT_SUBSYSTEM_LIST',    url: '#/report/plan/SCurve_MS'},
      {type: 'Reports',    name: 'RPT_SYSTEM_LIST',       url: '#/report/plan/SCurve_MS'},
    ],

    columns: [
      {code: 'type',  tColor: '#333', width: 100, align: 'start'},
      {code: 'name',  tColor: '#333', width: 150, align: 'start'},
      {code: 'count', tColor: '#333', width: 50,  align: 'end'},
    ]
  }),
}